module.exports = __webpack_public_path__ + "img/pig6.8b26c5be.png";